import { DataTable, MainButton, PageWrapper, STATUSPAGE } from '@repo/ui';
import { PROFILE_TYPE } from 'domain/value-objects/profile-type';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';

import { makeAdministratorsListColumns } from '../common/columns/administrators-list-columns';
import { useAdministratorsList } from '../hooks/use-administrators-list';

export const AdministratorsList = () => {
  // Hooks
  const { auth, currentUser } = useAuth();
  const {
    listStatus,
    administratorsListData,
    paginationMetadata,
    debouncedRequestGetAllAdministrators,
    navigate,
    setListStatus,
    handleSortRemote,
    handlePageChange,
    requestDeleteAdministrator,
    handleSearchRemote,
    handleRowsPerPageChange,
  } = useAdministratorsList();

  useEffect(() => {
    if (
      auth?.activeProfile?.profileId !== PROFILE_TYPE.ADMINISTRATOR ||
      currentUser?.activeProfile?.profileId !== PROFILE_TYPE.ADMINISTRATOR
    ) {
      navigate('/dashboard', { replace: true });
    }
  }, [auth?.activeProfile?.profileId, currentUser?.activeProfile?.profileId]);

  useEffect(() => {
    if (
      auth?.activeProfile?.profileId !== PROFILE_TYPE.ADMINISTRATOR ||
      currentUser?.activeProfile?.profileId !== PROFILE_TYPE.ADMINISTRATOR
    ) {
      return;
    }

    const valuesToSubmit = {
      page: paginationMetadata.selectedPage.toString(),
      length: paginationMetadata.rowsPerPage.toString(),
      order: paginationMetadata.sortDirection,
      orderColumn: paginationMetadata.orderColumn,
      query: encodeURIComponent(paginationMetadata.searchString),
    };
    setListStatus(STATUSPAGE.LOADING);

    debouncedRequestGetAllAdministrators(valuesToSubmit);
  }, [
    paginationMetadata,
    auth?.activeProfile?.profileId,
    currentUser?.activeProfile?.profileId,
  ]);

  return (
    <PageWrapper title="Usuários">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Usuários</h4>
          <p className="text-muted mb-0">
            Controle de acesso de usuários do sistema
          </p>
        </div>

        <MainButton
          onClick={() => {
            navigate('/cadastros/usuarios/novo');
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo Usuário
        </MainButton>
      </div>

      <Card>
        <CardBody>
          <DataTable
            noDataTitle="Nenhum usuário encontrado"
            noDataDescription="Não há usuários cadastrados no momento."
            noDataVariant="default"
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => {
                  navigate(`/cadastros/usuarios/editar/${cellProps.id}`);
                },
                nameFeatherIcon: 'edit',
                classNameColorIcon: 'primary',
              },
            ]}
            canSearch
            searchServer
            onSearch={handleSearchRemote}
            columns={makeAdministratorsListColumns()}
            data={administratorsListData?.data}
            loading={listStatus === STATUSPAGE.LOADING}
            pagination
            handleDelete={(id) => requestDeleteAdministrator({ id })}
            paginationServer
            paginationTotalRows={administratorsListData?.total}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            sortServer
            onSort={handleSortRemote}
          />
        </CardBody>
      </Card>
    </PageWrapper>
  );
};
